<template>
  <div class="HEATMAP_CURRENCY">
    <div
      v-if="echartData && echartData.objectInfos.length == 1"
      class="singeHeatMap"
      :class="isBorder ? 'isBorder' : ''"
    >
      <div
        :style="{
          height: singleHeight + 'vw',
          border: isBorder ? `0.8vw solid #eaedf1` : `0`,
          borderRadius: isBorder ? `1vw` : `0`,
        }"
      >
        <div
          id="bargraph5"
          ref="bargraph5"
          @click.stop="downLoad($event)"
        ></div>
      </div>
    </div>

    <div
      class="echarts_box"
      v-if="echartData && echartData.objectInfos.length == 2"
    >
      <div class="teamOne" ref="teamOne">
        <div
          ref="team1"
          id="team1"
          v-if="doubleW !== 0"
          :class="isBorder ? 'isBorder' : ''"
          :style="{
            width: doubleW + 'vw',
            height: doubleH + 'vw',
            left: `${(doubleH - doubleW) / 2}vw`,
            bottom: `${(doubleH - doubleW) / 2}vw`,
            border: isBorder ? `0.8vw solid #eaedf1` : `0`,
          }"
          @click.stop="downLoad($event)"
        ></div>
      </div>
      <div
        class="teamTwo"
        :style="{
          width: `${
            echartData && echartData.objectInfos.length == 2
              ? heatMapTwoWidthPer * 100
              : 0
          }'%'`,
        }"
      >
        <div
          ref="team2"
          id="team2"
          v-if="doubleW !== 0"
          :class="isBorder ? 'isBorder' : ''"
          :style="{
            width: doubleW + 'vw',
            height: doubleH + 'vw',
            left: `${(doubleH - doubleW) / 2}vw`,
            bottom: `${(doubleH - doubleW) / 2}vw`,
            border: isBorder ? `0.8vw solid #eaedf1` : `0`,
          }"
          @click.stop="downLoad($event)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// 通用热区图
import HMap from 'heatmap.js'
import cup_base_data_mixin from '@mixins/cup_base_data'
import { HEATMAP_CURRENCY } from './mockData.json'
export default {
  name: 'HEATMAP_CURRENCY',
  mixins: [cup_base_data_mixin],
  props: {
    isBorder: {
      type: Boolean,
      default: true,
    },
    // echartData: {
    //   default: function() {
    //     return {
    //       title: "",
    //       dimensions: [],
    //       resultData: [],
    //       itemList: [],
    //       teamInfos: [],
    //       objectInfos: [
    //         {
    //           objectLogo: "",
    //           objectName: ""
    //         },
    //       ],
    //       dimensionNames: [],
    //       eventData:{
    //       }
    //     };
    //   }
    // },
    isDownLoadImg: {
      // 是否可以下载图片
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataArr: [],
      parentHeight: 300, // 图表父元素的高度 px，父元素的宽高，以高为基础，计算宽度，计算公式为w=h*1.5
      singleHeight: 0, // vw
      cloumnWidth: 0, // vw
      cloumnHeight: 0, // vw
      isDb: true, // 双击禁止
      doubleW: 0, // vw
      doubleH: 0, // vw
      echartData: null,
      bgImgWHRatio: 1018 / 686, //足球背景图比例
      borderWidth: 0.8, // vw
      viewportWidth: 750, //px2vw 的init视图宽度
      dpi: 1,
      heatMapTwoWidthPer: 0.46, //当展示2个竖行的热区图，每一个热区图宽46%，这里存储浮点数
    }
  },
  components: {},
  created() {
    this.echartData = HEATMAP_CURRENCY
    if (this.isBigMobile()) {
      this.dpi = 1
    } else {
      this.dpi = window.devicePixelRatio ? window.devicePixelRatio : 1
    }
  },
  mounted() {
    this.singleHeight = Math.ceil(
      (this.parentHeight / this.viewportWidth) * 100
    )
    this.cloumnHeight = this.singleHeight - this.borderWidth * 2
    this.cloumnWidth = Math.ceil(this.cloumnHeight * this.bgImgWHRatio)
    this.$nextTick(() => {
      this.initMap()
    })
  },
  watch: {
    echartData: {
      handler() {
        this.singleHeight = Math.ceil(
          (this.parentHeight / this.viewportWidth) * 100
        )
        this.cloumnHeight = this.singleHeight - this.borderWidth * 2
        this.cloumnWidth = Math.ceil(this.cloumnHeight * this.bgImgWHRatio)
        // this.initMap()
        if (this.echartData && this.echartData.objectInfos.length == 1) {
          this.createMap(this.heatmapInstance)
        } else {
          if (this.doubleW) {
            this.createTeamMap1()
            this.createTeamMap2()
          }
        }
      },
      deep: true,
    },
    cloumnWidth() {
      this.getWH()
    },
  },
  methods: {
    getWH() {
      const team1W = this.cloumnWidth * this.heatMapTwoWidthPer
      const team1H = this.cloumnHeight
      this.doubleW = team1H
      this.doubleH = team1W
    },
    initMap() {
      if (this.echartData && this.echartData.objectInfos.length == 1) {
        this.heatmapInstance = HMap.create({
          container: this.$refs.bargraph5,
          backgroundColor: 'rgba(255,255,255,0.3)', // '#121212'    'rgba(0,102,256,0.2)'
          radius: this.isDownLoadImg ? 90 : 30, // [0,+∞)
        })
        this.createMap()
      } else if (this.echartData && this.echartData.objectInfos.length == 2) {
        this.team1 = HMap.create({
          container: this.$refs.team1,
          backgroundColor: 'rgba(255,255,255,.3)', // '#121212'    'rgba(0,102,256,0.2)'
          radius:
            (this.echartData.isOneGame
              ? this.isDownLoadImg
                ? 50
                : 20
              : this.isDownLoadImg
              ? 40
              : 10) / this.dpi, // [0,+∞)
        })
        this.team2 = HMap.create({
          container: this.$refs.team2,
          backgroundColor: 'rgba(255,255,255,0.3)', // '#121212'    'rgba(0,102,256,0.2)'
          radius:
            (this.echartData.isOneGame
              ? this.isDownLoadImg
                ? 50
                : 20
              : this.isDownLoadImg
              ? 40
              : 10) / this.dpi, // [0,+∞)
        })
        if (this.doubleW) {
          this.createTeamMap1()
          this.createTeamMap2()
        }
      }
    },
    initData(w, h, data, column) {
      var dataArr = []
      if (!data) {
        this.dataArr = dataArr
        return
      }
      if (column) {
        data.forEach((item, index) => {
          dataArr[index] = {
            x: parseInt((item.x / 100) * w),
            y: -parseInt((item.y / 100) * h) + h,
            value: item.r * 1 > 0.6 ? 0.6 : item.r,
          }
        })
      } else {
        data.forEach((item, index) => {
          dataArr[index] = {
            x: parseInt((item.x / 100) * w),
            y: -parseInt((item.y / 100) * h) + h,
            value: item.r * 1 > 0.6 ? 0.6 : item.r,
          }
        })
      }
      this.dataArr = dataArr
    },
    createMap() {
      // 单场图配置
      var points = []
      var max = 1
      var width = this.$refs.bargraph5.clientWidth
      var height = this.$refs.bargraph5.clientHeight
      this.initData(width, height, this.echartData.eventData['object0'])
      var data = {
        max: max,
        data: this.dataArr,
      }
      //因为data是一组数据,web切图报价所以直接setData
      this.heatmapInstance.setData(data)
    },
    createTeamMap1() {
      // 双队伍 队伍一
      var points = []
      var max = 1
      var width = this.$refs.team1.clientWidth
      var height = this.$refs.team1.clientHeight
      this.initData(width, height, this.echartData.eventData['object0'], 1)
      var data = {
        max: max,
        data: this.dataArr,
      }

      this.team1.setData(data)
    },
    createTeamMap2() {
      // 双队伍 队伍二
      var points = []
      var max = 1
      var width = this.$refs.team2.clientWidth
      var height = this.$refs.team2.clientHeight
      this.initData(width, height, this.echartData.eventData['object1'], 2)
      var data = {
        max: max,
        data: this.dataArr,
      }

      this.team2.setData(data)
    },
    downLoad(e) {
      if (!this.isDownLoadImg) {
        return
      }
      if (!this.isDb) {
        return
      }
      this.isDb = false
      this.$nextTick(() => {
        const el = e.target
        console.debug(el)
        this.toImage.getOptions({
          el: el,
        })
      })
      setTimeout(() => {
        this.isDb = true
      }, 500)
    },
  },
}
</script>
<style lang="scss" scoped>
.HEATMAP_CURRENCY {
  color: #fff;
  width: 100%;
  height: 100%;
  .singeHeatMap {
    &.isBorder {
      box-sizing: content-box;
    }
  }
  .echarts_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
  }
}
#bargraph5,
#team1,
#team2 {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  background-size: 100% 100% !important;
  background-image: var(--mixtmt_ball_border_bg);
  background-repeat: no-repeat;
  background-position: center;
  font-size: 0;
  // border:6px solid #EAEDF1;
  // border-radius: 14px;
  // box-sizing: content-box;
}
#bargraph5 {
  width: 100%;
  height: 100%;
  transform: rotateX(0deg);
}

.teamOne,
.teamTwo {
  position: relative;
  width: 46%;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
}
#team1,
#team2 {
  transform: rotateX(0deg) rotateY(0deg) rotateZ(-90deg);
  &.isBorder {
    box-sizing: content-box;
  }
}
</style>
